import { makeStyles, tokens } from '@fluentui/react-components';
import { FC } from 'react';
import { SelectedWhitePaperCell } from '../../data-types/selectedWhitePaperCell';
import { customPalette } from '../../theme';

const useStyles = makeStyles({
    root: {
        display: 'flex',
        backgroundColor: customPalette.lightBlue,
        borderRadius: tokens.borderRadiusMedium,
        alignItems: 'center',
        boxShadow: '0px 0.3px 0.9px 0px rgba(0, 0, 0, 0.10), 0px 1.6px 3.6px 0px rgba(0, 0, 0, 0.13)',
        padding: '4px 16px',
        justifyContent: 'space-between',
    },
    description: {
        color: customPalette.grey222222,
        fontStyle: 'normal',
        fontWeight: tokens.fontWeightSemibold,
        lineHeight: '24px',
    },
    amount: {
        color: `var(--type-colors-primary, ${customPalette.blueDark})`,
        fontStyle: 'normal',
        fontWeight: tokens.fontWeightBold,
        lineHeight: '24px',
    },
});

export interface IAccountAmountSectionProps {
    data?: SelectedWhitePaperCell;
}

const AccountAmountSection: FC<IAccountAmountSectionProps> = ({ data }) => {
    const headerText = data?.description;
    const amount = data?.valueEx;
    const styles = useStyles();

    return (
        <div id='accountAmountSection' className={styles.root}>
            <div className={styles.description}>
                <h3>{headerText}</h3>
            </div>
            <div className={styles.amount}>
                <span>{amount}</span>
            </div>
        </div>
    );
};

export default AccountAmountSection;
